import { AxiosPromise, AxiosResponse } from 'axios'
import { createSuperPacksClient } from './createSuperPacksClient';
import { getSuperPacks, searchSuperPacks, createSuperPack, getSuperPack, deleteSuperPack, updateSuperPack } from './methods';
import { CreateSuperPackData, SuperPacksClient as BaseSuperPacksClient, SuperPacksClientOption } from './types'
import { Superpack} from "lib/types";

export default function SuperPacksClient(options?: SuperPacksClientOption): SuperPacksClient {
  const commonOptions = {}

  return createSuperPacksClient({
    ...commonOptions,
    ...options,
    methods: {
      getSuperPacks,
      createSuperPack,
      getSuperPack,
      deleteSuperPack,
      searchSuperPacks,
      updateSuperPack,
    },
  })
}

export type SuperPacksClient = BaseSuperPacksClient & {
  readonly getSuperPacks: () => AxiosPromise<Superpack[]>,
  readonly createSuperPack: (data?: CreateSuperPackData) => AxiosPromise<Superpack>,
  readonly updateSuperPack: (id: string, data?: Partial<CreateSuperPackData>) => AxiosPromise<Superpack>,
  readonly getSuperPack: (id: string) => AxiosPromise<AxiosResponse<Superpack>>,
  readonly deleteSuperPack: (id: string) => AxiosPromise<''>,
  readonly searchSuperPacks: (data: { search: string }) => AxiosPromise<Superpack[]>,
}
